import React, { useState } from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'
import { showToast } from '../../../Components/Utlis/toastUtlis';
import { ApiService } from '../../../Components/Services/apiServices';
import { Link, useNavigate } from 'react-router-dom'
import '../../../Components/Css/register.css'

const Register = () => {

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    organisation_name: '',
    email: '',
    mobile: '',
    subscription_type: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.first_name) {
      showToast("error", "Please Enter First Name")
      setLoading(false);
      return false
    }

    if (!formData.last_name) {
      showToast("error", "Please Enter Last Name")
      setLoading(false);
      return false
    }

    if (!formData.organisation_name) {
      showToast("error", "Please Enter Organisation Name")
      setLoading(false);
      return false
    }

    if (!formData.email) {
      showToast("error", "Please Enter Email")
      setLoading(false);
      return false
    }
    if (!formData.mobile) {
      showToast("error", "Please Enter Mobile")
      setLoading(false);
      return false
    }
    if (!formData.subscription_type) {
      showToast("error", "Please Choose Subscription Type")
      setLoading(false);
      return false
    }
    if (!formData.password) {
      showToast("error", "Please Enter Password")
      setLoading(false);
      return false
    }



    try {
      const registerData = await ApiService.Commanpostrequest("register", formData);
      if (registerData.success) {
        showToast("success", "Registeration Successfully!")
        setFormData({
          first_name: '',
          last_name: '',
          organisation_name: '',
          email: '',
          mobile: '',
          subscription_type: '',
          password: '',
        });
        navigate("/login")
      } else {
        showToast("error", "Registration failed. Please try again.")
      }
    } catch (error) {
      console.error("Registration error: ", error)
      showToast("error", "An error occurred. Please try again later.")

    } finally {
      setLoading(false);
    }

  }

  return (
    <div>

      <Header />
      <section>
        <div className="container-fluid">
          <div className="user signinBx">
            <div className="imgBx">
              <img src="https://sigohrmlpadmin.loopring.in/front/images/banner1.png" className="img-fluid hero-img aos-init aos-animate" alt data-aos="zoom-out" data-aos-delay={300} />
            </div>
            <div className="formBx">
              <form onSubmit={handleRegister}>
                <h2>Start 7-day Free Trial</h2>
                <span className="text-center" style={{ color: 'blue' }}>No credit card required</span>
                <div className="row">
                  <div className="col-lg-6">
                    <label htmlFor="first_name">First Name <span style={{ color: 'red' }}>*</span></label>
                    <input type="text" name="first_name" placeholder="Enter your first name"
                      onChange={handleChange}
                      value={formData.first_name}
                    />

                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="last_name">Last Name <span style={{ color: 'red' }}>*</span></label>
                    <input type="text" name="last_name" placeholder="Enter your last name"
                      onChange={handleChange}
                      value={formData.last_name}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="organisation_name">Organisation Name <span style={{ color: 'red' }}>*</span></label>
                    <input type="text" name="organisation_name" placeholder="Enter your organization name"
                      onChange={handleChange}
                      value={formData.organisation_name}
                    />

                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="email">Email Address <span style={{ color: 'red' }}>*</span></label>
                    <input type="email" name="email" placeholder="Enter your organization email address"
                      onChange={handleChange}
                      value={formData.email}
                    />

                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="mobile">Phone Number <span style={{ color: 'red' }}>*</span></label>
                    <div className="d-flex">
                      <select className="form-select w-25 me-2">
                        <option>+91</option>
                        <option>+11</option>
                        <option>+91</option>
                      </select>
                      <input type="phone" name="mobile" className="form-control w-75"
                        placeholder="Enter phone number"
                        onChange={handleChange}
                        value={formData.mobile}
                      />
                    </div>

                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="subscription_type">Choose Subscription Type <span style={{ color: 'red' }}>*</span></label>
                    <select name="subscription_type" className="form-select" value={formData.subscription_type}
                      onChange={handleChange}>
                      <option value="" disabled selected>Select Subscription Type </option>
                      <option value="HRMS and Recruitment">HRMS and Recruitment</option>
                      <option value="HRMS">HRMS</option>
                      <option value="Recruitment">Recruitment </option>
                    </select>

                  </div>
                  <div className="col-lg-6 password-toggle" style={{ width: '100%' }}>
                    <label htmlFor="password">Password <span style={{ color: 'red' }}>*</span></label>
                    <input type={showPassword ? 'text' : 'password'} name="password" placeholder="Enter your password"
                      onChange={handleChange}
                      value={formData.password}
                    />


                    <span className="toggle-icon" onClick={togglePasswordVisibility}>
                      <i className={`fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                    </span>
                  </div>
                </div>
                <button className="btn btn-success w-100" type="submit" disabled={loading}>
                  {loading ? 'Loading...' : 'Start Free Trial'}
                </button>
                <p className="text-center mt-3" style={{ fontSize: 14 }}>By continuing you agree with the our <a href="/privacy-policy" className>Privacy Policy</a> and <a href="/terms-of-service" className>Terms &amp; Conditions</a></p>
                <p className="signup">Already have an account? <a href="http://localhost:8000/organisation/login">Sign In.</a></p>
              </form>
            </div>
          </div>
        </div>
      </section>




      <Footer />
    </div>
  )
}

export default Register
